enum TenantSessionAPIEnum {
  orgless = 'orgless',
  organization = 'organization',
  customer = 'customer',
  native = 'native'
}

export default TenantSessionAPIEnum;
